<script lang="ts">
	import { onMount, onDestroy } from 'svelte';
	import { page } from '$app/stores';
	import { goto } from '$app/navigation';
	import { posthog } from '$lib/initPosthog';
	import authStore from '$lib/authStore';
	import Header from '$components/Header.svelte';
	import GridAligner from '$components/GridAligner.svelte';
	import { BoardsClient } from '$lib/boardsClient';
	import type { Board, BoardImagePin } from '$lib/diffusionApi';
	import { initPosthog } from '$lib/initPosthog';

	let subscriptions: (() => void)[] = [];

	onMount(async () => {
		initPosthog();

		document.body.style.overflowY = 'auto';

		subscriptions.push(
			authStore.subscribe(async (auth) => {
				const user = auth.user;
				if (user === undefined) return;
				if (user === null) {
					goto('/sign-up', { replaceState: true });
					return;
				}
				if (user.email) posthog.identify(user.email);
			})
		);
	});

	onDestroy(() => {
		for (const _ of subscriptions) _();
	});
</script>

<svelte:head>
	<title>Utilities - Iliad</title>
</svelte:head>

<div
	class="w-screen min-h-screen h-fit flex flex-col justify-start items-center font-inter
	bg-primary-50 dark:bg-zinc-900 overflow-x-hidden text-zinc-900 dark:text-zinc-200"
>
	<div class="w-full h-12 px-2 py-2 flex flex-row justify-start items-center z-10">
		{#if $authStore.isLoggedIn}
			<Header />
			<div class="w-4"></div>
			<div>Utilities</div>
		{/if}
	</div>
	<div class="h-2"></div>
	<div
		class="w-[370px] sm:w-[520px] md:w-[625px] flex flex-row justify-start items-start flex-wrap text-sm"
	>
		<a
			href="/seamless-texture-checker"
			class="w-44 h-44 mb-2 mx-1 p-4 flex flex-col justify-center items-center border rounded shadow-md
            bg-primary-25 border-primary-200 text-zinc-900 hover:brightness-90
            dark:bg-navy-900 dark:border-zinc-800 dark:text-zinc-200 dark:hover:brightness-150"
		>
			<span>
				Seamless texture checker <i class="ml-1 fa-solid fa-arrow-up-right-from-square"></i>
			</span>
		</a>
		<a
			href="/pbr-material-visualizer"
			class="w-44 h-44 mb-2 mx-1 p-4 flex flex-col justify-center items-center border rounded shadow-md
            bg-primary-25 border-primary-200 text-zinc-900 hover:brightness-90
            dark:bg-navy-900 dark:border-zinc-800 dark:text-zinc-200 dark:hover:brightness-150"
		>
			<span>
				PBR material visualizer <i class="ml-1 fa-solid fa-arrow-up-right-from-square"></i>
			</span>
		</a>
		<a
			href="/image-to-prompt-generator"
			class="w-44 h-44 mb-2 mx-1 p-4 flex flex-col justify-center items-center border rounded shadow-md
            bg-primary-25 border-primary-200 text-zinc-900 hover:brightness-90
            dark:bg-navy-900 dark:border-zinc-800 dark:text-zinc-200 dark:hover:brightness-150"
		>
			<span>
				Image to prompt generator <i class="ml-1 fa-solid fa-arrow-up-right-from-square"></i>
			</span>
		</a>

		<div class="h-12"></div>
	</div>
</div>

<style>
</style>
